module.exports = __webpack_public_path__ + "img/богатство лета 110х90.1f8f8d22.jpg";